import DepositMultipleTokens from "./DepositMultipleTokens";

export default DepositMultipleTokens;
